var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9146 9.51915C18.0904 9.7661 18.1782 9.88957 18.2236 10.0685C18.2588 10.2071 18.2588 10.411 18.2236 10.5497C18.1782 10.7286 18.0904 10.8521 17.9146 11.099C16.7185 12.78 13.6262 16.5591 10 16.5591C6.3738 16.5591 3.28149 12.78 2.08536 11.099C1.90964 10.8521 1.82178 10.7286 1.77639 10.5497C1.7412 10.411 1.7412 10.2071 1.77639 10.0685C1.82178 9.88957 1.90964 9.7661 2.08536 9.51915C3.28149 7.83817 6.3738 4.05908 10 4.05908C13.6262 4.05908 16.7185 7.83817 17.9146 9.51915Z",
    stroke: "#148AAD",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 10.3091C12.25 11.5517 11.2426 12.5591 10 12.5591C8.75736 12.5591 7.75 11.5517 7.75 10.3091C7.75 9.06644 8.75736 8.05908 10 8.05908C11.2426 8.05908 12.25 9.06644 12.25 10.3091Z",
    stroke: "#148AAD",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.10e2130b66241c66821e57347e6292e9.svg";
export { ForwardRef as ReactComponent };